<template>
  <div class="bidding-activities">
    <second-menu-link-content>
      <template v-slot:header>
        <span>活动竞价</span>
      </template>
      <template v-slot:content>
        <div class="bidding-activities-main">
          <div class="search">
            <span class="label">活动状态：</span>
            <el-select
              class="white"
              clearable
              placeholder="请选择状态"
              v-model="biddingStatus"
            >
              <el-option
                v-for="(item, index) in biddingStatusList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button class="btn-blue" @click="searchBiddingStatusList">筛选</el-button>
          </div>
          <div class="table-img">
            <el-table :data="tableData" style="width: 100%" v-loading="loading">
              <el-table-column prop="activityName" label="活动名称" min-width="200">
                <template slot-scope="scope">
                  <p class="name">{{scope.row.activityName}}</p>
                </template>
              </el-table-column>
              <el-table-column label="竞价时间" min-width="184px">
                <template slot-scope="scope">
                  <p>{{scope.row.biddingBeginTime}}至<br>{{scope.row.biddingEndTime}}</p>
                </template>
              </el-table-column>
              <el-table-column label="活动时间" min-width="184px">
                <template slot-scope="scope">
                  <p>{{scope.row.beginTime}}至<br>{{scope.row.endTime}}</p>
                </template>
              </el-table-column>
              <el-table-column prop="statusValue" label="状态"></el-table-column>
              <el-table-column label="操作" width="140">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.status > 0"
                    class="btn-text"
                    type="text"
                    @click="toBiddingDetailsDetailById(scope.row)"
                  >查看</el-button>
                  <el-button
                    v-else
                    class="btn-text"
                    type="text"
                    @click="toBiddingDetailsDetailById(scope.row)"
                  >参加</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagination-tpl-container">
              <pagination-tpl
                :total="totalNum"
                :currentPage="currentPage"
                @queryChange="onQueryChange"
              ></pagination-tpl>
            </div>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script>
import { setSupplierActivityInfo } from 'common/js/storage';
import { formaTimeToSecond } from "common/js/util.js";
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationTpl from "base/PaginationTpl";
import Supplier from "models/spl/supplier.js";
const supplier = new Supplier();
export default {
  components: {
    SecondMenuLinkContent,
    PaginationTpl
  },
  data() {
    return {
      biddingStatusList: [
        { label: '未参加', value: 0},
        { label: '已参加', value: 1},
      ],
      biddingStatus: "",
      tableData: [],
      totalNum: 0,
      currentPage: 1,
      loading: true,
    };
  },
  created() {
    this.getBiddingActivitiesList();
  },
  methods: {
    // 获取活动竞价列表
    getBiddingActivitiesList() {
      let currentPage = this.currentPage;
      supplier.getSupplierBiddingList(currentPage, this.biddingStatus).then(res => {
        if (res.success) {
          this.totalNum = res.result.totalNum;
          let arr = [];
          res.result.items.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.activityName = value.activityName;
            obj.beginTime = formaTimeToSecond(value.beginTime);
            obj.endTime = formaTimeToSecond(value.endTime);
            obj.biddingBeginTime = formaTimeToSecond(value.biddingBeginTime);
            obj.biddingEndTime = formaTimeToSecond(value.biddingEndTime);
            obj.status = value.num;
            obj.boothNum = value.boothNum;
            obj.basePrice = value.basePrice;
            obj.promotionType = value.promotionType;
            obj.statusValue = value.num == 0?'未参加':'已参加';
            arr.push(obj);
          });
          this.tableData = arr;
          this.loading = false;
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: 'error',
            duration: 1000
          });
        }
      });
    },
    // 搜索
    searchBiddingStatusList() {
      this.getBiddingActivitiesList();
    },
    // 点击查看详情
    toBiddingDetailsDetailById(row) {
      setSupplierActivityInfo(row)
      this.$router.push({
        path: "/supplier/spl-bidding/bidding-index/bidding-details",
      });
    },
    // 翻页
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.getBiddingActivitiesList();
    },
  }
};
</script>

<style lang="scss" scoped>
.bidding-activities {
  width: 100%;
  height: 100%;
  .bidding-activities-main {
    .add-promotion {
      margin-bottom: 16px;
    }
    .search {
      padding: 16px;
      background: rgba(245, 247, 250, 1);
      border-radius: 4px;
      display: flex;
      margin-bottom: 20px;
      .label {
        line-height: 32px;
        font-size: 14px;
      }
      .el-input {
        width: 320px;
      }
      .el-button {
        margin-left: 16px;
      }
    }
    .table-img {
      .pagination-tpl-container {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
</style>
<style lang="scss">
.bidding-activities {
  .el-dialog {
    margin-top: 32vh!important;
    .el-dialog__header {
      border-bottom: 1px solid #EEE;
      .el-dialog__title {
        font-size: 16px;
        font-weight: bold;
        color: #666666;
        line-height: 24px;
      }
    }
    .el-dialog__footer {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 72px;
      border-top: 1px solid #EEE;
    }
    .el-dialog__body {
      padding-bottom: 0;
      .el-form {
        padding: 20px 0px;
        .el-form-item__content {
          .el-input,
          .el-input__inner {
            height: 32px;
          }
          .line {
            text-align: center;
          }
        }
        .el-form-item {
          height: 32px;
          margin-bottom: 16px;
        }
        .el-form-item:nth-last-child(1) {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>